export const shoppingcart = {
    title: "Order summary",
    title_payment: "Checkout",
    title_subscription: "Subscription Summary",
    status: {
        your_order: "Your Order",
        payment: "Payment"
    },
    delivery_method: {
        pickup_at: "Pickup at",
        change: "Change",
        time: "Time",
        now: "Now"
    },
    your_order_title: "Your Order",
    add_more_button: "Add more",
    baht: "Baht",
    subtotal: "Subtotal",
    delivery_fee: "Delivery Fee",
    discount: "Discount",
    total: "Total",
    calculating: "Calculating",
    coupon_discount: "Coupon Discount",
    no_coupon: "Use Offers to get discounts",
    additional_message: "Additional Message",
    cutlery: "Cutlery",
    sauce: "Sauce",
    type_your_request: "Type Your request...",
    total_bath: "Total : {0} Baht",
    you_will_get_points: "You will get {0} crowns from this order",
    checkout: "Checkout",
    popup_upsale: {
        your_may_also_like: "Your may also like",
        total: "Current Total : {0} Baht",
        proceed_to_checkout: "Proceed to checkout",
    },
    
    profile: {
        firstname: {
            name: 'Name',
            placeholder: 'Name',
            required: 'Please enter Name',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'Mobile no.',
            placeholder: 'Mobile no.',
            required: 'Mobile no.',
            too_short: 'Mobile no must be {0} digits',
            invalid: 'Incorrect Mobile no format',
        },
    },
    payment_method: "Payment Method",
    cash: "Cash",
    free: "Free",
    credit: "Credit/Debit card",
    add_credit: "Add credit card",
    request_tax: "Request Tax invoice",
    placeorder: "Place Order",
    popup_loading_driver: {
        please_wait: "Please Wait...",
        find_driver: "We are finding you a nearby driver.<br>You may be redirected for OTP payment verification.",
        find_not_found: "Sorry, We Could not find you a driver",
        try_again: "Try Again",
        cancel: "Cancel"
    },

    error_address_not_found: "please select a delivery address or store for self-pickup",
    error_credit: "Your payment was unsuccessful. Please try again.<br/>If the issue still occurred, please contact 1112",
    error_cart: "Some issues found with your item(s). Please check your shopping bag",
    error_cart_item: "This item is not valid for your select order type. Please delete and select this item again",
    error_book: "There is a problem with driver system. Please try again.",
    error_book_2: "Error: 404",
    popup_connection_error: {
        msg: "Connection problem. Please try again.",
        retry: "Retry",
        cancel: "Cancel"
    },
    popup_contact_bk: {
        msg: "Unable to proceed due to connection problem. Sorry for your inconvenience. Please contact 1112 to order",
        confirm: "Confirm"
    },
    popup_qr_payment: {
        title: "Payment infomation",
        total: "Total : {0} Baht",
        transaction_date: "Transaction date :",
        qr_time: "QR Code valid for",
        scan_qr_to_pay: "Scan QR code to pay",
        save_qr: "Save QR code",
        cancel: "Close"
    },
    popup_limit_order: {
        msg: "We apologize, but all our order slots are currently fully booked. Please place your order during a different hour slot.",
        btn_close: "Close"
    }
};
